import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMoonGlyphSecondary from './svgs/MoonGlyphSecondary.js';
import SvgMoonGlyph from './svgs/MoonGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var moonGlyph = (props => useIcon(SvgMoonGlyph, SvgMoonGlyphSecondary, props));

export { moonGlyph as default };
